// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SideBar_mainContainer__3w6CJ","logoContainer":"SideBar_logoContainer__2bxF1","navContainer":"SideBar_navContainer__1Bj3Q"};